<script lang="ts">
  import LoginPage from './pages/login-page.svelte'
  import Index from './pages/index.svelte'
  import { authState, AuthStateValues } from './services/auth-service'
</script>

{#if $authState === AuthStateValues.unknown}
  <main class="flex min-h-screen items-center justify-center">
    <p>Loading...</p>
  </main>
{:else if $authState === AuthStateValues.authed}
  <Index />
{:else}
  <LoginPage />
{/if}






